module.exports = __webpack_public_path__ + "static/img/p_16.7f4f9fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_16.png
// module id = mCjn
// module chunks = 9